import React from 'react'
import createCellEditor from './createCellEditor'
import { fromNullable, Just, Nothing } from 'data.maybe'
import styled from 'styled-components'

const Input = styled.input`
  border: 1px solid #4d90fe;
  text-align: center;
  box-shadow: none;
  ${({ width }) =>
    width &&
    `
    flex: 0 0 ${width};
    max-width: ${width};
    `};
`

export const regexChecker = ({ onEdit, regex }) => e =>
  fromNullable(e.target.value)
    .chain(v =>
      v.trim().length === 0 ? Just(v) : regex.test(v) ? Just(v) : Nothing()
    )
    .map(v => onEdit(v))
    .getOrElse('')

const RegexCheckedEditor = ({
  editContent,
  style,
  onBlur,
  onEdit,
  // parent,
  keyDown,
  regex,
  refBinder,
  width,
}) => {
  if (!regex) {
    /* eslint-disable no-console */
    console.log('WARNING: regex must be supplied!!!!!!')
    /* eslint-enable no-console */
  }
  return (
    <Input
      width={width}
      innerRef={refBinder}
      onKeyDown={keyDown}
      onBlur={onBlur}
      style={style}
      type="text"
      value={editContent}
      onChange={regexChecker({ onEdit, regex })}
      data-testid="grid-cell-editor"
    />
  )
}

export const createRegexCheckedEditor = regex =>
  createCellEditor(props => <RegexCheckedEditor {...props} regex={regex} />)

export const NumberEditor = createRegexCheckedEditor(/^(-)?\d*\.?\d*$/)
